// Copyright 2025, University of Maryland, All Rights Reserved
import { useEffect } from 'react'

interface AuthMenuSyncProps {
  menuOpen: boolean
}

/**
 * Keeps the umd-auth web component in sync with our local menu state without
 * leaking DOM mutation logic throughout the layout.
 */
export function AuthMenuSync({ menuOpen }: AuthMenuSyncProps) {
  useEffect(() => {
    const authElement = document.querySelector<HTMLElement>('umd-auth')
    if (!authElement) {
      return
    }

    authElement.classList.toggle('menu-open', menuOpen)
  }, [menuOpen])

  return null
}
